import { render, staticRenderFns } from "./SideNavigationLink.vue?vue&type=template&id=5d687836&scoped=true&"
import script from "./SideNavigationLink.vue?vue&type=script&lang=js&"
export * from "./SideNavigationLink.vue?vue&type=script&lang=js&"
import style0 from "./SideNavigationLink.vue?vue&type=style&index=0&id=5d687836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d687836",
  null
  
)

export default component.exports